import { useQuery } from '@tanstack/react-query'
import { fetchStorefrontSettings } from '../api/settings'
import { QUERY_KEYS } from '../constants/query'
import { FALLBACK_STOREFRONT_SETTINGS } from '../constants/settings'

export function useStorefrontSettings() {
  const query = useQuery({
    queryKey: QUERY_KEYS.settings,
    queryFn: fetchStorefrontSettings,
  })

  return {
    settings: query.data ?? FALLBACK_STOREFRONT_SETTINGS,
    loading: query.isPending && !query.data && !query.error,
  }
}
